import { useEffect, useMemo, useState } from 'react';

import readAltProductMedia from '../../../utils/read-alt-product-media';

import { Badges } from '../../../snippets';
import { ProductImage } from './ProductImage';
import { ProductMediaThumbnails } from './ProductMediaThumbnails';
import { ProductVideo } from './ProductVideo';
import { ProductMediaCalloutGrid } from './ProductMediaCalloutGrid';
import { ProductMediaSlider } from './ProductMediaSlider';
import { useOpenMediaModal } from './useOpenMediaModal';

export function ProductMediaAlt({ selectedMedia, selectedVariant }) {
  const { handleModal } = useOpenMediaModal();

  return (
    <div className="grid grid-cols-1 justify-between md:gap-8">
      {/* Primary Gallery Item */}
      <div className="order-0">
        <div className="relative bg-[#E6F0F8]">
          {selectedMedia.length && (
            <>
              <div className="hidden p-12 md:block">
                {selectedMedia[0].mediaContentType === 'VIDEO' ? (
                  <ProductVideo media={selectedMedia[0]} />
                ) : (
                  <button
                    className="block w-full"
                    type="button"
                    aria-label="Open product image in modal"
                    onClick={() =>
                      handleModal({
                        imageSrc: selectedMedia[0].image.src,
                        altText: selectedMedia[0].image.altText,
                      })
                    }
                  >
                    <ProductImage media={selectedMedia[0]} />
                  </button>
                )}
              </div>
              <div className="md:hidden">
                <ProductMediaSlider memoizedProductMedia={selectedMedia} />
              </div>
            </>
          )}

          <div className="pointer-events-none absolute left-0 top-0 z-[1] p-2.5 xs:p-4 md:p-3 xl:p-4">
            <Badges tags={selectedVariant?.product?.tags} />
          </div>
        </div>
      </div>

      {/* callout grid */}
      <ProductMediaCalloutGrid />

      {/* Gallery Thumbnails */}
      <div className="relative order-1 hidden w-full overflow-x-auto scrollbar-hide md:block ">
        {selectedMedia?.length > 0 && (
          <ProductMediaThumbnails selectedMedia={selectedMedia} />
        )}
      </div>
    </div>
  );
}

ProductMediaAlt.displayName = 'ProductMediaAlt';
